import type { FaireProductEntity } from "../../entity_types/product";

export const p_nenzd5g5y9: FaireProductEntity = {
  token: "p_nenzd5g5y9",
  type: "product",
  name: "Kitty's Bloody Cocktail 1oz Hazelnut Butter Bar 2026",
  brandToken: "b_c8gh4g2kci",
  brandName: "FINE & RAW",
  imageUrl:
    "https://cdn.faire.com/fastly/bd3b4f81ce99a1d3fb264964f32d7b612860052c1a5127c57b071c8c1cc53e87.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.65,
  description:
    "A vampire cat. A cup of pure blood. Just another perfectly normal Halloween night.\n\nOur Hazelnut Bar is dressed for the occasion and ready to charm customers all season long. Crafted with organic cacao and generously loaded with Oregon hazelnuts, this bar is rich, nutty, creamy, and deeply satisfying. The perfect balance of dark chocolate intensity and velvety hazelnut goodness.\n\nWrapped in delightfully strange artwork by Yusuke Okada, it's the kind of chocolate bar shoppers pick up for the packaging and return for because they can't stop thinking about the chocolate.\n\nProduct Highlights:\n• 1 oz chocolate bar\n• Organic, bean-to-bar chocolate\n• Vegan-friendly & gluten-free\n• Made with Oregon hazelnuts\n• Small-batch crafted in Brooklyn, NY\n• Seasonal Halloween artwork by Yusuke Okada\n• Perfect for gifting, checkout displays, and trick-or-treat alternatives\n\nIngredients: Organic cacao bean, organic coconut sugar, organic hazelnuts, organic cacao butter, and sea salt.\n\nNutty. Creamy. Dark. Balanced. The kind of trouble that keeps.",
  tags: [],
  msrpDollars: 5.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:36.013Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
